<template>
    <div class="h-full text-black">
        <div class="flex justify-between mb-24">
            <p class="text-heading-2 font-semibold">{{ `${$t('multi-posting.tabs.job-boards.title')} - ${$t('general.jobs.title')}` }}</p>
            <div @click="$emit('close')">
                <SvgIcon
                    type="cancel"
                    class="cursor-pointer w-24 h-24"
                />
            </div>
        </div>

        <div class="border rounded-4 p-24">
            <div class="flex items-center mb-24">
                <div class="w-64 h-64">
                    <img :src="product.logo_square_url" :alt="`${product.name}-logo`">
                </div>
                <div class="flex flex-col ml-24">
                    <p class="text-body font-semibold mb">{{ product.name }}</p>
                    <div class="flex gap-16">
                        <p class="text-body-sm">{{ `${product.duration.period} ${product.duration.range}` }}</p>
                        <p class="text-body-sm">{{ `${product.vonq_price[0].amount} ${product.vonq_price[0].currency}` }}</p>
                        <simple-button
                            :href="product.url"
                            look="text"
                            lowercase
                            target="_blank"
                            type="link"
                        >
                            {{ product.url }}
                        </simple-button>
                    </div>
                </div>
            </div>

            <div class="border-t w-full my-24"></div>

            <loading v-if="fetchingProductJobs" />
            <JobBoardVacancyList v-else :product="product" />
        </div>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon.vue";
import Loading from "../ui/Loading.vue";
import JobBoardVacancyList from "./JobBoardVacancyList.vue";
import {mapActions, mapState} from "pinia";
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import SimpleButton from '../ui/SimpleButton.vue';

export default {
    name: 'JobBoardVacancies',
    components: {JobBoardVacancyList, Loading, SvgIcon, SimpleButton},
    props: {
        product: { type: Object, required: true },
    },
    data() {
        return {
            fetchingProductJobs: false,
        }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['productJobData']),
        jobIds() {
            return this.productJobData.map(x => x.job_id);
        }
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['fetchProductJobs']),
    },
    created() {
        this.fetchingProductJobs = true;
        // fetch campaign jobs by id
        this.fetchProductJobs({productId: this.product.id, jobIds: [...new Set(this.jobIds)]})
            .then(() => this.fetchingProductJobs = false);
    },
    beforeMount() {
        // reset scroll position to 0
        document.getElementById('content-container').scrollTop = 0;
    }
}
</script>
